export default () => ({

    categories: [],
    activeCategorySlug: null,
    activeArticleSlug: null,

});
